import { Mesh, RepeatWrapping, TextureLoader } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { GUI } from "dat.gui";
import model from "../../../../../assets/models/subtopicthree/GLB_Tablet.glb";
import { imgsTopicThree } from "../../../../../assets/activityes/topicthreeActvone";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";

export class tabletPlanograma extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);

		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.helpers();
		this.listenersobserver();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Pantalla_Tablet = gltf.scene.getObjectByName("Pantalla_Tablet", true);
			this.updateMaterialScreen(imgsTopicThree.planogramaTablet);
			// this.Pantalla_Tablet.material.map.repeat.set(1, 1);
			// this.Pantalla_Tablet.material.map.rotation = Math.PI / ;
		});
	}

	listenersobserver() {
		ObserverEmitter.on(EVENTS.subtopicThree.activityone.hiddenTablet, () => {
			this.visible = false;
		});
	}

	updateMaterialScreen(img) {
		const imgLoader = new TextureLoader();
		const textura = imgLoader.load(img);
		this.Pantalla_Tablet.material.map = textura;
		this.Pantalla_Tablet.material.lightMap = textura;
		this.Pantalla_Tablet.material.lightMapIntensity = 1;
		this.Pantalla_Tablet.material.map.wrapS = RepeatWrapping;
		this.Pantalla_Tablet.material.map.wrapT = RepeatWrapping;
		this.Pantalla_Tablet.material.map.repeat.y = -1;
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("tabllet-planogra");
		premiaFolder.add(this.position, "x", -10, 10).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -10, 10).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -10, 10).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		// premiaFolder.open();
	}

	renderAnimations() { }
}
